// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownMenu_dropdown__oqCFe","dropdown__content":"DropdownMenu_dropdown__content__KGlOB","dropdown__top":"DropdownMenu_dropdown__top__-KKo7"};